import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, DoBootstrap, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastModule } from 'primeng/toast';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DataModule } from './@data/data.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoadingInterceptor } from './@data/interceptors/loading.interceptor';
//import { AuthInterceptor } from './@data/interceptors/auth.interceptor';
import { KeycloakService, KeycloakAngularModule } from 'keycloak-angular';
import { initializer } from './pages/utils/app-init';

//import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { MenubarModule } from 'primeng/menubar';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { SharedModule } from 'primeng/api';
import { TabMenuModule } from 'primeng/tabmenu';
import { MegaMenuModule } from 'primeng/megamenu';

import { RouterModule, Routes } from '@angular/router';

let keycloakService: KeycloakService = new KeycloakService();

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

const EXTERNAL_MODULES = [
  TranslateModule.forRoot({
    loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
    },
    defaultLanguage: 'es',
    useDefaultLang: true
  }),
  ToastModule,
  TableModule,
  CardModule,
  CheckboxModule,
  CalendarModule,
  MenubarModule,
  InputTextModule,
  ButtonModule,
  SharedModule,
  TabMenuModule,
  MegaMenuModule,
  NgxSpinnerModule,
  RouterModule
];

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    KeycloakAngularModule,
    BrowserModule,
    BrowserAnimationsModule,
    DataModule,
    HttpClientModule,
    AppRoutingModule,
    ...EXTERNAL_MODULES
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: APP_INITIALIZER, useFactory: initializer, multi: true, deps: [KeycloakService, HttpClient]},
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
